<template>
	<div class="demodetail_wrap">
		<!--代码部分-->
			<div class="code_wrap">
			<div class="title_wrap">
				<div class="left">
					<span>{{title}}</span>
					<span @mouseenter.stop="showShade($event)" @mouseleave.stop="hideShade($event)" 
						 class="el-icon-info">
						<!--遮罩-->
						<div class="shadebox">
							<div id="demoimgmark1">
								{{abstract}}
							</div>
								
						</div>
					</span>
				</div>
			</div>
			<codemirror
		style='text-align: left;'
		ref='myCm'
		v-model='code'
		:options="{
	    mode:'javascript',    
	    json : true,
	    lineNumbers: true,
	    firstLineNumber: 1,
	    foldGutter: true,
    	gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
  }">
	</codemirror>
		</div>
		<!--显示部分-->
		<div class="container_wrap">	
			<div id="detail_right">
				<iframe :srcdoc="code" id="iframe" scrolling="no"></iframe>
			</div>
			
			<ul>
				<li class="even">
					<a @click="issueDemo">提问</a>
				</li>
				<li class="even">
					<a @click="helpDemo">开发文档</a>
				</li>
				<li>
					<a href="#">
						<i v-if='!collection_flag' @click="collectDemo($event)" class="el-icon-star-off">收藏</i>
						<i v-if='collection_flag' @click="collectDemo($event)" class="el-icon-star-on" style="color:rgb(6, 106, 243);">收藏</i>
						</a>
				</li>
				<li>
					<a @click="downloadDemo">下载</a>
				</li>
			</ul>
			 
			
		</div>
		<submitquestionpop ref='submitquestionpop'></submitquestionpop>
	</div>
</template>

<script>
	import submitquestionpop from '@/messageBox/submitquestionpop.vue'
	import { codemirror } from 'vue-codemirror'
	  require('codemirror/mode/javascript/javascript')
	  require('codemirror/mode/vue/vue.js')	
	  require('codemirror/addon/hint/show-hint.js')
	  require('codemirror/addon/hint/show-hint.css')
	  require('codemirror/addon/hint/javascript-hint.js')
	  
	  require('codemirror/addon/fold/brace-fold.js')
	  require('codemirror/addon/fold/comment-fold.js')
	  require('codemirror/addon/fold/foldcode.js')
	  require('codemirror/addon/fold/foldgutter.js')
	  require('codemirror/addon/fold/foldgutter.css')
　　require('codemirror/addon/fold/foldcode.js')
　　require('codemirror/addon/fold/foldgutter.js')
　　require('codemirror/addon/fold/brace-fold.js')
　　require('codemirror/addon/fold/xml-fold.js')
　　require('codemirror/addon/fold/indent-fold.js')
　　require('codemirror/addon/fold/markdown-fold.js')
　　require('codemirror/addon/fold/comment-fold.js')
	export default {
		data() {
			return{
				exampleUrl:``,
				uuid:'',			//Demo uuid
				title:'',			//Demo标题
				abstract:'',	//Demo 简介
				catalog_name:'',	//Demo开发文档
				code:'',			//Demo 代码
				collection_flag:0
			}
		},
		components: {
			submitquestionpop,
			codemirror
		},
		watch:{
			code:function(){
				let that = this;
				that.$nextTick(that.common.iframeScreenButton(that.exampleUrl))
			}
		},
		mounted(){
			let that=this;
			this.uuid = this.$route.query.uuid;
			//获取数据
			this.$http.get(
				that.apiUrl+'index.php?m=Api&c=Content&a=demoDetail',
				{
					params: {  
						"uuid":this.uuid,
						'userCode':sessionStorage.getItem('usercode')
						
					}  
				}
			).then(response => {
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
//					this.$router.push('/404')
//					this.$message({
//								message: '请求错误',
//								type: 'warning',
//								dangerouslyUseHTMLString:true,
//								customClass: 'message-warning',
//							});
					return;
				}
				
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					
					//显示空数据页面
					this.$message({
								message: '暂无数据',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
					return;
				}
				this.exampleUrl=response.body.data.exampleUrl;
				this.code = response.body.data.vc_content;
				this.title = response.body.data.vc_title;
				this.abstract = response.body.data.vc_abstract;
				this.catalog_name = response.body.data.catalog_name;
				this.collection_flag = response.body.data.is_collection;
			}, response => {
//				console.log("error");
			});
		},
		methods: {
			showShade(event) {
				event.target.children[0].style.display='table'
				
			},
			hideShade(event) {
				event.target.children[0].style.display='none'
			},
			//帮助文档
			helpDemo(){
				this.$router.push({
					path: 'developdocument',
					query: {
						type: 4,
						name: this.catalog_name,
						uuid: this.uuid,
					}
				})
			},
			
			//收藏
			collectDemo(event){
				let that=this;
				//判断用户是否登录
				if(this.isLogin()){
					
					//判断是收藏还是取消收藏
					if(!this.collection_flag){
						var url = that.apiUrl+"index.php?m=Api&c=user&a=collectionAdd";
					}else{
						var url = that.apiUrl+"index.php?m=Api&c=user&a=saveCollection"
					}
					
					//发送请求,收藏或取消收藏
					this.$http.post(url,
						{
							userCode:sessionStorage.getItem('usercode'),
							type:1,
							contentCode:this.uuid
						},
						{emulateJSON: true}
					).then(
						(response)=>{
							//判断是否收藏|取消收藏成功
							if(response.body.status == 1){
									sessionStorage.setItem('isRefresh',true);
									//修改收藏按钮状态
									if(!this.collection_flag){
										this.collection_flag=1;
										event.target.className='el-icon-star-on'
										event.target.style.color='#076bf2'
									}else{
										this.collection_flag=0;
										event.target.className='el-icon-star-off'
										event.target.style.color=''
									}
									
							}else{
//								alert(response.body.massage);
							}	
						},
						(error)=>{
//							console.log("error");
						}
					);
				}
			},
			
			//提问
			issueDemo(){
				
				//判断用户是否登录
				if(this.isLogin()){
					
					//弹出提问框
					this.$refs.submitquestionpop.opensubmitquestionpop('1',this.title);
				}
			},
			
			//下载
			downloadDemo(){
				let _this=this;
				//发送请求,收藏或取消收藏
				if(this.isLogin()){
				this.$http.post(
					_this.apiUrl+"index.php?m=Api&c=content&a=dmeoZip",
					{
						code:this.code,
						uuid:this.uuid
					},
					{emulateJSON: true}
				).then(
					(response)=>{
						if(response.body.status != 1){
//							alert(response.body)
						}else{
							window.location.href = _this.apiUrl+'index.php?m=Api&c=content&a=demoDownload&url='+response.body.data+'&filename='+this.title+'.zip';
						}
						
					},
					(error)=>{
//						console.log("error");
					}
				);
				}
			},
			
			//判断是否登录
			isLogin(){
				
				//判断当前是否为登录状态
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == ""){
					
					//弹出登录页面
					
					//显示登录页面
//					this.$refs.commonhead.flag = true;
					this.$message({
								message: '请先登录',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
					return false;
				
				}else{
					
					return true;
				}
			},
		}
	}
</script>

<style>
	.demodetail_wrap{
		margin: 0 auto;
		background: #f3f3f3;
		height:100%;
	}
	.demodetail_wrap .code_wrap{
		width:35%;
		height:100%;
		background: #fff;
		float: left;
	}
	.demodetail_wrap .code_wrap .title_wrap{
		box-sizing: border-box;
		position: absolute;
		background: #f3f3f3;
		width:35%;
		height: 5%;
		box-shadow: 3px 3px 3px #eee;
		padding: 0 10px;
	}
	.demodetail_wrap .code_wrap .title_wrap .left{
		float: left;
		font-size: 14px;
		line-height: 45px;
		margin-left: 10px;
		font-weight: bolder;
	}
	.demodetail_wrap .code_wrap .title_wrap .right{
		float: right;
		line-height: 30px;
	}
	.demodetail_wrap .code_wrap .title_wrap .right .el-button{
		padding:4px 20px;
		border-radius: 13px;
		
	}
	
	.demodetail_wrap .code_wrap .title_wrap	.shadebox{		
		overflow: hidden;
		word-wrap: break-word;
		background: #000000;
	 	filter:alpha(opacity=80);   
      	-moz-opacity:0.8;   
      	-khtml-opacity: 0.8;   
      	opacity: 0.8;  
		width: 100%;
		height: 250px;
		line-height: 20px;
		position: absolute;
		left: 0;
		top: 80%;
		color: white;
		display: none;
		z-index: 100;		
		text-align: left;		
	}
	.left>.el-icon-info{
		line-height:30px; height:30px; margin-left:5px;color: #999999;
	}
	.shadebox #demoimgmark1{
		width: 70%;
		max-height: 175px;
		overflow: hidden;
		padding: 0 15%;
		display: table-cell;
		vertical-align: middle;
		position: absolute;
		top: 50%;
		left: 50%;
		font-family: "微软雅黑";
		-webkit-transform:translate(-50%,-50%) ;
		-moz-transform: translate(-50%,-50%);
		-ms-transform: translate(-50%,-50%);
		-o-transform: translate(-50%,-50%);
		transform: translate(-50%,-50%);
	}
	.demodetail_wrap .container_wrap{
		position: relative;
		float: right;
		width:65%;
		height:100%;
	}
	.demodetail_wrap .container_wrap h3{
		position: absolute;
		bottom: 60px;
		right:20px
	}
	.demodetail_wrap .container_wrap ul{
		position: absolute;
		bottom: 15px;
		right: 100px;
		list-style: none;
	}
	.demodetail_wrap .container_wrap li{
		float: left;
		cursor: pointer;
	}
	.demodetail_wrap .container_wrap li a{
		display: block;
		text-decoration: none;
		background: #ddd;
		margin-left: 8px;
		width:90px;
		height: 30px;
		font-size: 14px;
		line-height: 30px;
		text-align: center;
		border-radius: 3px;
		color: #222222;
	}
	
	/*底部*/
	.commonfoot{
		background: #F3F3F3;
	}
	.commonfoot .container{
		width:70%;
		height:40px;
		margin:0 auto;
	}
	.copyright{		
		display: inline-block;
		float: left;
		margin-left: 50px;
	}
	.commonfootright{
		display: inline-block;
		float: right;
		margin-right:30px;
	}
	/*编辑器 */
	.CodeMirror{
		left: 0;
		top: 0;
		height: 95%;
	}
	.vue-codemirror {
    position: relative;
    left: 0;
    top: 5%;
    height: 100%;
    width: 100%;
}
	.vue-codemirror-wrap{
		width: 100%;
		height: 100%;
	}
	#detail_right{width:100%;height:100%;}
	#iframe{
		width: 100%;
		border:0;
		height: 100%;
	}
	.full-screen{
		cursor: pointer;
		width: 30px;
		height: 30px;
		position: absolute;
		right: 45px;
		bottom: 15px;
	}
	.full-screen i{
		color:#666666 ;
		font-size: 30px;
	}
	.el-icon-thirdicon-suoxiao{
		font-size: 24px;
	}
	.demodetail_foot{
		width: 100%;
		position: fixed;
		bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// src/detail/demodetail.vue